import { AxiosError } from "axios";

import { NeedHelp } from "../../../../../need-help";

// TODO: - Stop using when the project is migrated.
import { UserSessionI } from "../../../../../../old/redux/auth/authTypes";
// TODO: - Stop using when the project is migrated.
import { loginSuccess } from "../../../../../../old/redux/auth/authActions";
// TODO: - Stop using when the project is migrated.
import { saveSecureStorage } from "../../../../../../old/utils/storage";

import toast from "react-hot-toast";

// TODO: - Stop using when the project is migrated.
import { useDispatch } from "react-redux";
// TODO: - Stop using when the project is migrated.
import { useNavigation } from "@react-navigation/native";
import { useTranslation } from "react-i18next";

import {
  AuthLayout,
  Button,
  Form,
  Input,
} from "../../../../../../shared/infrastructure";
import { IconButton, InputAdornment } from "@material-ui/core";
import {
  IoEye,
  IoEyeOff,
  IoLockClosedOutline,
  IoPersonOutline,
} from "react-icons/io5";
import React, { useState } from "react";
import { animated, useSpring } from "react-spring";
import { login, useAuth } from "../../../store/auth-context";
import { object, string } from "yup";

type LoginFormType = {
  email: string;
  password: string;
};

const PasswordInput = (): React.ReactElement => {
  const [t] = useTranslation("global");
  const [visible, setVisible] = useState(false);

  return (
    <Input
      name="password"
      placeholder={t<string>(
        "context.public.screens.login.form.fields.password.placeholder"
      )}
      type={visible ? "text" : "password"}
      variant="outlined"
      classNames={{
        input: "xl:mt-[14px]",
      }}
      inputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={() => setVisible((v) => !v)}
              edge="end"
            >
              {visible ? (
                <IoEye className="text-base text-black" />
              ) : (
                <IoEyeOff className="text-base text-black" />
              )}
            </IconButton>
          </InputAdornment>
        ),
        startAdornment: (
          <InputAdornment position="start">
            <IoLockClosedOutline className="text-base text-black" />
          </InputAdornment>
        ),
      }}
      rootInputProps={{
        className: "h-6 px-1 py-1.5 text-[0.875rem]",
      }}
    />
  );
};

export const Login = (): React.ReactElement => {
  const { setData } = useAuth();
  // TODO: - Stop using when the project is migrated.
  const { navigate } = useNavigation();
  const [isLoginLoading, setIsLoginLoading] = useState<boolean>(false);
  // TODO: - Stop using when the project is migrated.
  const dispatch = useDispatch();

  const [t] = useTranslation("global");

  const styles = useSpring({
    from: { x: 512, opacity: 0 },
    to: { x: 0, opacity: 1 },
  });

  return (
    <AuthLayout>
      <div className="flex w-full justify-center xl:justify-end">
        <animated.div style={styles}>
          <Form<LoginFormType>
            onSubmit={(values: LoginFormType) => {
              setIsLoginLoading(true);
              login(setData, values)
                .then((auth) => {
                  // TODO: - Stop using when the project is migrated.
                  void saveSecureStorage(auth, "user");
                  // TODO: - Stop using when the project is migrated.
                  dispatch(loginSuccess(auth as UserSessionI));
                })
                .catch((error: AxiosError<{ code: string }>) => {
                  setIsLoginLoading(false);
                  const errorMessage = [
                    `context.public.screens.login.form.messages.${
                      error?.response?.data?.code?.toLowerCase() || ""
                    }`,
                    "context.public.screens.login.form.messages.error",
                  ];
                  toast.error(t<string>(errorMessage), {
                    className: "bg-white text-black text-sm max-w-2xl",
                  });
                });
            }}
            schema={object().shape({
              email: string()
                .required(
                  t<string>(
                    "context.public.screens.login.form.fields.username.validations.required"
                  )
                )
                .email(
                  t<string>(
                    "context.public.screens.login.form.fields.username.validations.type"
                  )
                ),
              password: string().required(
                t<string>(
                  "context.public.screens.login.form.fields.password.validations.required"
                )
              ),
            })}
            className="w-full max-w-[380px] rounded-xl bg-white py-8 px-8 md:w-[327px] lg:w-[380px] lg:px-12 lg:py-5"
          >
            <h1 className="mb-5 text-2xl font-bold lg:mb-[35.5px] lg:text-3.5xl">
              {t("context.public.screens.login.form.title")}
            </h1>
            <div className="grid gap-0.5">
              <Input
                name="email"
                placeholder={t<string>(
                  "context.public.screens.login.form.fields.username.placeholder"
                )}
                variant="outlined"
                inputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <IoPersonOutline className="text-base text-black" />
                    </InputAdornment>
                  ),
                }}
                rootInputProps={{
                  className: "h-6 px-1 py-1.5 text-[0.875rem]",
                }}
              />

              <PasswordInput />
            </div>
            <div className="flex flex-row items-center justify-between xl:mt-[14px]">
              <Button
                type="button"
                appearance="link"
                onClick={() => navigate("forgot-password")}
                className="w-max truncate p-0 font-sans text-[13px] font-semibold capitalize text-black"
              >
                {t<string>(
                  "context.public.screens.login.form.buttons.forgot-password"
                )}
              </Button>

              <NeedHelp />
            </div>

            <Button
              className="mb-1 mt-3 max-h-10 w-full text-sm font-normal lg:mb-7 lg:mt-2"
              status={isLoginLoading ? "loading" : "default"}
            >
              {t<string>("context.public.screens.login.form.buttons.submit")}
            </Button>
          </Form>
        </animated.div>
      </div>
    </AuthLayout>
  );
};
